import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Country, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DpGeoLocationApiService {
  readonly #httpClient = inject(HttpClient);
  readonly #occEndpoints = inject(OccEndpointsService);

  getGeolocationData(latitude: number, longitude: number): Observable<Country> {
    const url = this.#occEndpoints.buildUrl(
      'geolocation',
      { queryParams: { latitude, longitude } },
      { baseSite: false },
    );
    return this.#httpClient.get<Country>(url);
  }
}
